import styled from 'styled-components';
import Tappable from 'react-tappable/lib/Tappable';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';

import TappableCard from '../../components/common/TappableCard';
import { FaArrowLeft, FaTimes } from 'react-icons/fa';
import { Text } from '../../components/common/Text';
import NeedHelp from '../../components/hospitalization/need-help';
import { getDeficiencyQueryHistory } from '../../services';
import { uploadDocuments } from '../../services/claims';
import Header from '../../components/common/Header';
import { logEvent } from '../../utils/logEvent';
import MessageModal from '../../components/pharmacy/MessageModal';
import UploadModal from '../../components/common/UploadModal';
import StyledTappable from '../../components/common/StyledTappable';
import { FadeInTransition } from '../../components/transitions/transitions';

import documentImg from '../../images/reimbursement/document-voilet.svg';
import arrowLeft from '../../images/common/arrow-left.svg';
import pdfIcon from '../../images/lab-test/pdf-icon.svg';
import eyeIcon from '../../images/common/eye.svg';
import { openFileViewer } from '../../actions';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  padding: 50px 10px 10px 10px;
  border-bottom: 1px solid #e2e3ea;
`;

const BackContainer = styled(TappableCard)`
  //   margin-right: 0.5rem;
  padding: 0.5rem;
  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const StyledArrow = styled(FaArrowLeft)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const HeaderText = styled(Text)`
  margin-right: 0.625rem;
  color: #0f0b28;
  font-weight: 600;
`;

const BodyContainer = styled.div`
  background-color: #fffaeb;
  height: 100svh;
  overflow-y: scroll;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  background: ${({ removePadding, isUser }) =>
    removePadding ? 'none' : isUser ? '#EAE7FF' : 'var(--primary-button)'};
  margin: ${(props) =>
    props.isUser ? '20px 10px 10px 80px' : '20px 80px 10px 10px'};
  padding: ${({ removePadding }) => (removePadding ? '0px' : '12px')};
  border-radius: ${(props) =>
    props.isUser ? '12px 12px 0px 12px' : '12px 12px 12px 0px'};
`;

const Message = styled.div`
  color: ${({ text }) => (text ? '#FF754C' : '#fff')};
  border-radius: 8px;
  font-size: 12px;
  margin: 6px 0px;
`;

const PdfBlock = styled.a`
  background-color: white;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  margin: 6px 0px;
  font-size: 12px;
  display: flex;
  font-weight: 600;
  align-items: center;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`;

const ImgWrapper = styled.div`
  position: relative;
  width: 49%;
`;

const ImgBlock = styled.img`
  height: 12vh;
  width: 100%;
  border-radius: 4px;
  border: 1px solid white;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
`;

const OverlayText = styled.div`
  color: white;
  font-size: 1.5em;
  font-weight: bold;
`;

const OverlayImg = styled.img`
  position: absolute;
  object-fit: cover; /* Ensure the image covers the entire overlay */
`;

const StatusContainer2 = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  background: #ffffff;
  border: 1px solid ${(props) => props.borderColor || 'var(--primary-button)'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
`;

const StatusDetail = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border-bottom-color: ${(props) => (props.bottomBorder ? '#f0f3f6' : '#fff')};
  border-bottom-width: ${(props) => (props.bottomBorder ? '1px' : '0px')};
`;

const Text3 = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.25px;
  line-height: 18px;
  flex: 1;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => (props.active ? '#413958' : '#767787')};
`;

const StatusSubLableText = styled.p`
  margin-top: 5px;

  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #302e6b;
`;

const StatusUploadSubContainer = styled.div`
  padding: 12px;
  margin-top: 15px;
  background: #f0f3f6;
  opacity: 0.8;
  border-radius: 12px;
`;

const StatusSubText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #0f0b28;
`;

const AttachFileContainer = styled(Tappable)`
  position: relative;
  flex-shrink: 0;
  margin: 0 0.5rem;
  background-image: ${() => `url(${pdfIcon})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: 2rem;
  width: 45px;
  height: 64px;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
`;

const AttachImageContainer = styled(Tappable)`
  position: relative;
  flex-shrink: 0;
  margin: 0 0.5rem;
  background-image: ${(props) => `url(${props.fileUrl})`};
  background-repeat: no-repeat;
  background-size: cover;
  width: 45px;
  height: 64px;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 0px 1px 0px black;
`;

const CloseContainer = styled(StyledTappable)`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff7268;
  border-radius: 6px;
  padding: 2px;
`;

const CloseIcon = styled(FaTimes)`
  font-size: 14px;
  color: white;
`;

const AttachedFilesContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: wrap;
`;

const AttachmentInput = styled.input`
  display: none;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  max-height: 300px;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: hidden;
  font-size: 16px;
  line-height: 1.5;
  resize: none;
  border: 1px solid var(--primary-button);
  border-radius: 8px;
`;

const QueryHistory = (props) => {
  const authToken = useSelector((state) => state?.user?.authToken);
  const dispatch = useDispatch();
  const { history } = props;
  const { location } = history;
  const { deficientId, claimInfoV2, documentsDeficientDetails } =
    location?.state;
  const [formattedData, setFormattedData] = useState(null);
  const [invoiceFileParts, setInvoiceFileParts] = useState([]);
  const [prescriptionFileParts, setPrescriptionFileParts] = useState([]);
  const [labsReportFileParts, setLabsReportFileParts] = useState([]);
  const [medsInvoiceFileParts, setMedsInvoiceFileParts] = useState([]);
  const [labsInvoiceFileParts, setLabsInvoiceFileParts] = useState([]);
  const [merParts, setMerParts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showUploadOption, setShowUploadOption] = useState(false);
  const [imageType, setImageType] = useState('');
  const [uploadingImage, setUploadingImage] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [knowMoreModal, setKnowMoreModal] = useState(false);
  const [documentsDeficient, setDocumentsDeficient] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [remark, setRemark] = useState('');
  const [showRemarkInput, setShowRemarkInput] = useState(false);

  const groupByDate = (data) => {
    return data.reduce((acc, current) => {
      const datePart = current.createdAt.split(', ')[1];
      if (!acc[datePart]) {
        acc[datePart] = [];
      }

      // Separate documentUrl into documentImage and documentPdf
      const documentImage = [];
      const documentPdf = [];

      current.documentUrl.forEach((url) => {
        if (/\.(png|jpg|jpeg)$/i.test(url)) {
          documentImage.push(url);
        } else if (/\.(pdf)$/i.test(url)) {
          documentPdf.push(url);
        }
      });

      acc[datePart].push({
        ...current,
        documentImage,
        documentPdf,
      });

      return acc;
    }, {});
  };

  const fetchDeficiencyQueryHistory = async (deficientId) => {
    try {
      const res = await getDeficiencyQueryHistory(
        authToken,
        deficientId,
        claimInfoV2.reimbursementId
      );
      const groupedData = groupByDate(res?.formattedData);
      setFormattedData(groupedData);
    } catch (error) {
      console.error('Error fetching deficiency query history:', error);
    }
  };

  const onImageDataReceive = () => {
    setShowModal(false);
    const inputElem = document.getElementById('photoAttachment');

    const file = inputElem.files[0];

    if (imageType === 'invoice') {
      setInvoiceFileParts([
        ...invoiceFileParts,
        {
          name: 'invoiceFile',
          filename: file.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    } else if (imageType === 'prescription') {
      setPrescriptionFileParts([
        ...prescriptionFileParts,
        {
          name: 'prescriptionFile',
          filename: file.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    } else if (imageType === 'meds-invoice') {
      setMedsInvoiceFileParts([
        ...medsInvoiceFileParts,
        {
          name: 'medicineInvoice',
          filename: file.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    } else if (imageType === 'labs-invoice') {
      setLabsInvoiceFileParts([
        ...labsInvoiceFileParts,
        {
          name: 'labInvoice',
          filename: file.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    } else if (imageType === 'lab-report') {
      setLabsReportFileParts([
        ...labsReportFileParts,
        {
          name: 'labReport',
          filename: file?.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    } else if (imageType === 'mer') {
      setMerParts([
        ...merParts,
        {
          name: 'merFile',
          filename: file.name,
          data: file,
          type: 'image/jpeg',
        },
      ]);
    }
  };

  const onPDFDataReceive = () => {
    setShowModal(false);
    const inputElem = document.getElementById('fileAttachment');

    const file = inputElem.files[0];
    if (imageType === 'invoice') {
      setInvoiceFileParts([
        ...invoiceFileParts,
        {
          name: 'invoiceFile',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    } else if (imageType === 'prescription') {
      setPrescriptionFileParts([
        ...prescriptionFileParts,
        {
          name: 'prescriptionFile',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    } else if (imageType === 'meds-invoice') {
      setMedsInvoiceFileParts([
        ...medsInvoiceFileParts,
        {
          name: 'medicineInvoice',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    } else if (imageType === 'labs-invoice') {
      setLabsInvoiceFileParts([
        ...labsInvoiceFileParts,
        {
          name: 'labInvoice',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    } else if (imageType === 'lab-report') {
      setLabsReportFileParts([
        ...labsReportFileParts,
        {
          name: 'labReport',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    } else if (imageType === 'mer') {
      setMerParts([
        ...merParts,
        {
          name: 'merFile',
          filename: file.name,
          data: file,
          type: 'application/pdf',
        },
      ]);
    }
  };

  const updateReimbursement = (s) => {
    setUploadingImage(true);
    const { baseUrl } = props;

    logEvent('OPD Reimbursement Status Document Uploaded', {
      referenceId: claimInfoV2.reimbursementId,
      patientName: claimInfoV2.patientInfo
        ? claimInfoV2.patientInfo.name
        : null,
      procedureName: claimInfoV2.procedureName,
    });

    const sTypes = s.map((item) => item.type);

    const formData = new FormData();
    formData.append('date', claimInfoV2.admissionDate);
    formData.append('reimbursementId', claimInfoV2.reimbursementId);
    formData.append('userRemark', remark);
    formData.append('requestStatus', 1);

    if (
      (prescriptionFileParts.length > 0 && invoiceFileParts.length > 0) ||
      (((sTypes.includes('prescription') && prescriptionFileParts.length > 0) ||
        !sTypes.includes('prescription')) &&
        ((sTypes.includes('invoice') && invoiceFileParts.length > 0) ||
          !sTypes.includes('invoice')) &&
        ((sTypes.includes('lab-report') && labsReportFileParts.length > 0) ||
          !sTypes.includes('lab-report')))
    ) {
      if (invoiceFileParts.length > 0) {
        // body.push(invoiceFileParts);
        invoiceFileParts.forEach((file) => {
          formData.append('invoiceFile', file.data);
        });
      }
      if (labsReportFileParts.length > 0) {
        // body.push(labsReportFileParts);
        labsReportFileParts.forEach((file) => {
          formData.append('labReport', file.data);
        });
      }
      if (prescriptionFileParts.length > 0) {
        // body.push(prescriptionFileParts);
        prescriptionFileParts.forEach((file) => {
          formData.append('prescriptionFile', file.data);
        });
      }
      uploadDocuments(formData, authToken)
        .then((apiResponse) => {
          console.log({ apiResponse, baseUrl }, 'uploadFileUrl response');
          if (apiResponse.message === 'success') {
            setUploadingImage(false);
            setShowMessageModal(true);
            setModalHeader('Additional Documents Submitted');

            setModalMessage(
              'Please refer to the documents section below to see all uploaded documents'
            );
            fetchDeficiencyQueryHistory(deficientId);
          } else if (apiResponse.message === 'failure') {
            setModalHeader('Error');
            setShowMessageModal(true);
            setUploadingImage(false);
            setModalMessage(apiResponse.errorMessage);
          } else {
            setModalHeader('Image Not Supported');
            setShowMessageModal(true);
            setUploadingImage(false);
            setModalMessage(
              'File format not supported! Upload a jpg/jpeg image.'
            );
          }
        })
        .catch((err) => {
          console.log({ err }, 'error response while calling uploadFileUrl');
          setUploadingImage(false);
        });
    } else {
      setUploadingImage(false);
      alert('Oops Please upload all required documents.');
    }
  };

  const removeFile = (ele, idx) => {
    let PresdeleteImage = prescriptionFileParts.filter((el, fileindex) => {
      return fileindex !== idx;
    });
    setPrescriptionFileParts(PresdeleteImage);

    let invoiceDeleteImage = invoiceFileParts.filter((elm, fileindx) => {
      return fileindx !== idx;
    });
    setInvoiceFileParts(invoiceDeleteImage);
  };

  const handleSubmit = (message) => {
    // Check if invoice, prescription, and lab report are required
    const isInvoiceRequired = message.find(
      (msg) => msg.type === 'invoice'
    )?.isDocumentRequired;
    const isPrescriptionRequired = message.find(
      (msg) => msg.type === 'prescription'
    )?.isDocumentRequired;
    const isLabReportRequired = message.find(
      (msg) => msg.type === 'lab-report'
    )?.isDocumentRequired;

    // Check conditions for file parts
    const condition1 = isInvoiceRequired ? invoiceFileParts?.length > 0 : true;
    const condition2 = isPrescriptionRequired
      ? prescriptionFileParts?.length > 0
      : true;
    const condition3 = isLabReportRequired
      ? labsReportFileParts?.length > 0
      : true;
    // Check if only text is present
    const ifOnlyHasText =
      message?.documentType?.length === 0 ||
      message?.filter((item) => item?.isDocumentRequired).length === 0;

    const ifDocumentMandatory =
      message?.filter((item) => item?.isDocumentRequired).length > 0;
    // Determine if submission is allowed

    if (
      (ifOnlyHasText && remark.length > 0) ||
      (condition1 && condition2 && condition3 && !ifOnlyHasText)
    ) {
      return (
        <StatusDetail>
          <p
            className="txt-white-600-14 lab-home-btn-blue pt-10 pb-10 hover mt-20"
            style={{ background: 'var(--primary-button)' }}
            onClick={() => updateReimbursement(message)}
          >
            Submit
          </p>
        </StatusDetail>
      );
    } else {
      return null;
    }
  };

  const renderUploadedFile = (ele, idx) => {
    const { fileUrl, data, type } = ele;
    try {
      const blobUrl =
        fileUrl || (data instanceof Blob && URL.createObjectURL(data));
      if (!blobUrl) {
        throw new Error('Invalid file object');
      }

      if (fileUrl && fileUrl.endsWith('pdf')) {
        return (
          <AttachFileContainer
            key={blobUrl}
            fileUrl={blobUrl}
            onTap={() => {
              document.querySelector(`#image-anchor-${type}-${idx}`).click();
            }}
          >
            <a
              href={blobUrl}
              target="_blank"
              rel="noopener noreferrer"
              id={`image-anchor-${type}-${idx}`}
              style={{ display: 'none' }}
            />
          </AttachFileContainer>
        );
      }
      return (
        <AttachImageContainer
          key={blobUrl}
          fileUrl={blobUrl}
          onTap={() => {
            document.querySelector(`#image-anchor-${type}-${idx}`).click();
          }}
        >
          <CloseContainer onTap={() => removeFile(ele.name, idx)}>
            <CloseIcon>
              <a
                href={blobUrl}
                target="_blank"
                rel="noopener noreferrer"
                id={`image-anchor-${type}-${idx}`}
                style={{ display: 'none' }}
              />
            </CloseIcon>
          </CloseContainer>
        </AttachImageContainer>
      );
    } catch (error) {
      console.error('Error creating object URL:', error, ele);
      return null;
    }
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const hideModal = () => {
    setShowMessageModal(false);
    setKnowMoreModal(false);
    setShowModal(false);
  };

  function onAttachPhoto() {
    document.querySelector('#photoAttachment').click();
  }

  function onAttachFile() {
    document.querySelector('#fileAttachment').click();
  }

  const handleAttachment = (type) => {
    if (type === 'photo') onAttachPhoto();
    else onAttachFile();
  };

  const handleImage = (imagelength, index) => {
    if (index === 3 && imagelength > 4) {
      openImageViewer(3);
    } else if (index === 1 && imagelength > 2) {
      openImageViewer(1);
    } else {
      openImageViewer(index);
    }
  };

  useEffect(() => {
    fetchDeficiencyQueryHistory(deficientId);
  }, []);

  return (
    <FadeInTransition in={true} timeout={200} mountOnEnter unmountOnExit appear>
      <OuterContainer>
        <Header title="Query History" needHelp />
        <BodyContainer>
          {formattedData &&
            Object.keys(formattedData).map((date) => (
              <div key={date} className="my-8">
                <div className="text-center">
                  <span
                    className="rounded-12 text-card-body"
                    style={{
                      padding: '2px 8px',
                      backgroundColor: '#EAE7FF',
                      color: '#3A2CA0',
                    }}
                  >
                    {date}
                  </span>
                </div>
                {formattedData[date].map((message, index) => (
                  <>
                    <MessageContainer
                      key={index}
                      isUser={message.isUser}
                      removePadding={message.isUser && !message.actionTaken}
                    >
                      {((message.isUser && message.actionTaken) ||
                        !message.isUser) &&
                      message?.documentImage?.length > 0 ? (
                        <ImgContainer>
                          {message?.documentImage
                            ?.slice(
                              0,
                              message?.documentImage?.length >= 4 ? 4 : 2
                            )
                            .map((src, index) => (
                              <ImgWrapper
                                key={index}
                                onClick={() =>
                                  handleImage(
                                    message?.documentImage?.length,
                                    index
                                  )
                                }
                              >
                                <ImgBlock src={src} alt="" />
                                <Overlay>
                                  {index === 3 &&
                                    message?.documentImage?.length > 4 && (
                                      <OverlayText>
                                        +{message?.documentImage?.length - 4}
                                      </OverlayText>
                                    )}
                                  {index === 1 &&
                                    message?.documentImage?.length > 2 &&
                                    message?.documentImage?.length < 4 && (
                                      <OverlayText>
                                        +{message?.documentImage?.length - 2}
                                      </OverlayText>
                                    )}
                                  {index === 0 &&
                                    message?.documentImage?.length === 1 && (
                                      <OverlayImg
                                        src={eyeIcon}
                                        alt=""
                                        className="w-8 h-8"
                                      />
                                    )}
                                </Overlay>
                              </ImgWrapper>
                            ))}
                        </ImgContainer>
                      ) : null}

                      {message.documentPdf.length > 0
                        ? message.documentPdf.map((doc, idx) => (
                            <PdfBlock
                              onClick={() =>
                                dispatch(
                                  openFileViewer({
                                    contentUrl: doc,
                                    title: 'Document',
                                    type: 'pdf',
                                  })
                                )
                              }
                            >
                              <img
                                className="h-4 w-4 mx-2"
                                src={documentImg}
                                alt=""
                              />
                              {`Document ${idx + 1}.pdf`}
                            </PdfBlock>
                          ))
                        : null}

                      {!message?.isUser &&
                      (message?.doctorRemark !== '' || message?.comment) ? (
                        <Message isUser={message?.isUser}>
                          {message?.doctorRemark && message?.doctorRemark ? (
                            <div>
                              <div>
                                <span className="text-body-s font-semibold ">
                                  Remarks:{' '}
                                </span>

                                <span>
                                  {' '}
                                  {message?.doctorRemark.split(' Reason')[0]}
                                </span>
                              </div>
                              {message?.doctorRemark.split('. Reason').length >
                              0
                                ? message?.doctorRemark
                                    .split('. Reason')
                                    .slice(1)
                                    .map((item) => (
                                      <p>
                                        Reason{' '}
                                        {
                                          message?.doctorRemark.split(
                                            ' Reason'
                                          )[1]
                                        }
                                      </p>
                                    ))
                                : null}
                            </div>
                          ) : null}
                          {message?.comment && message?.comment ? (
                            <div className="mt-2">
                              <span className="text-body-s font-semibold ">
                                Comments:
                              </span>
                              <span> {message?.comment}</span>
                            </div>
                          ) : null}
                        </Message>
                      ) : null}

                      {message.isUser && !message.actionTaken ? (
                        <div>
                          <StatusContainer2
                            borderColor={
                              message.isUser && !message.actionTaken
                                ? '#FF865C'
                                : false
                            }
                          >
                            <StatusDetail>
                              <Text3 active>
                                {documentsDeficientDetails?.label}
                              </Text3>
                              <StatusSubLableText>
                                {
                                  'Our team has identified some error in the document you uploaded earlier'
                                }
                              </StatusSubLableText>
                              {message?.doctorRemark &&
                              message?.doctorRemark ? (
                                <Message text>
                                  <span className="font-semibold">
                                    Remarks:{' '}
                                  </span>
                                  <span>{message?.doctorRemark}</span>
                                </Message>
                              ) : null}
                            </StatusDetail>
                            {message.isUser && !message.actionTaken ? (
                              <div>
                                {invoiceFileParts.length > 0 && (
                                  <div>
                                    <p className="txt-dgrey-600-12 mt-20 mb-5 flex justify-between items-center">
                                      <span>Invoice files</span>
                                      <span className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </span>
                                    </p>

                                    <AttachedFilesContainer>
                                      {invoiceFileParts.map(renderUploadedFile)}
                                      {invoiceFileParts.length > 0 &&
                                        invoiceFileParts.length < 5 && (
                                          <div
                                            class="dashed-add"
                                            style={{
                                              marginTop: '0.25rem',
                                              marginBottom: '0.5rem',
                                              width: 45,
                                            }}
                                            onClick={() => {
                                              setShowModal(true);
                                              setShowUploadOption(true);
                                              setImageType('invoice');
                                            }}
                                          >
                                            +
                                          </div>
                                        )}
                                    </AttachedFilesContainer>
                                  </div>
                                )}
                                {prescriptionFileParts.length > 0 && (
                                  <div>
                                    <p className="txt-dgrey-600-12 mt-20 mb-5 flex items-center justify-between">
                                      <span>Prescription files</span>
                                      <span className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </span>
                                    </p>

                                    <AttachedFilesContainer>
                                      {prescriptionFileParts.map(
                                        renderUploadedFile
                                      )}
                                      {prescriptionFileParts.length > 0 &&
                                        prescriptionFileParts.length < 5 && (
                                          <div
                                            class="dashed-add"
                                            style={{
                                              marginTop: '0.25rem',
                                              marginBottom: '0.5rem',
                                              width: 45,
                                            }}
                                            onClick={() => {
                                              setShowModal(true);
                                              setShowUploadOption(true);
                                              setImageType('prescriptionFiles');
                                            }}
                                          >
                                            +
                                          </div>
                                        )}
                                    </AttachedFilesContainer>
                                  </div>
                                )}
                                {labsReportFileParts.length > 0 && (
                                  <div>
                                    <p className="txt-dgrey-600-12 mt-20 mb-5 flex items-center justify-between">
                                      <span>Lab Report Files</span>
                                      <span className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </span>
                                    </p>

                                    <AttachedFilesContainer>
                                      {labsReportFileParts?.map(
                                        renderUploadedFile
                                      )}
                                      {labsReportFileParts.length > 0 &&
                                        labsReportFileParts.length < 5 && (
                                          <div
                                            class="dashed-add"
                                            style={{
                                              marginTop: '0.25rem',
                                              marginBottom: '0.5rem',
                                              width: 45,
                                            }}
                                            onClick={() => {
                                              setShowModal(true);
                                              setShowUploadOption(true);
                                              setImageType('lab-report');
                                            }}
                                          >
                                            +
                                          </div>
                                        )}
                                    </AttachedFilesContainer>
                                  </div>
                                )}
                                {invoiceFileParts?.length === 0 &&
                                message?.documentType?.some(
                                  (item) => item.type === 'invoice'
                                ) ? (
                                  <>
                                    <p
                                      className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                      onClick={() => {
                                        setShowModal(true);
                                        setShowUploadOption(true);
                                        setImageType('invoice');
                                      }}
                                    >
                                      Upload Invoice
                                    </p>
                                    {message?.documentType?.some(
                                      (item) =>
                                        item?.type === 'invoice' &&
                                        item?.isDocumentRequired
                                    ) ? (
                                      <p className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </p>
                                    ) : null}
                                  </>
                                ) : (
                                  ''
                                )}
                                {prescriptionFileParts?.length === 0 &&
                                message?.documentType?.some(
                                  (item) => item.type === 'prescription'
                                ) ? (
                                  <>
                                    <p
                                      className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                      onClick={() => {
                                        setShowModal(true);
                                        setShowUploadOption(true);
                                        setImageType('prescription');
                                      }}
                                    >
                                      Upload Prescription
                                    </p>
                                    {message?.documentType?.some(
                                      (item) =>
                                        item?.type === 'prescription' &&
                                        item?.isDocumentRequired
                                    ) ? (
                                      <p className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </p>
                                    ) : null}
                                  </>
                                ) : (
                                  ''
                                )}
                                {labsReportFileParts?.length === 0 &&
                                message?.documentType?.some(
                                  (item) => item?.type === 'lab-report'
                                ) ? (
                                  <>
                                    <p
                                      className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                      onClick={() => {
                                        setShowModal(true);
                                        setShowUploadOption(true);
                                        setImageType('lab-report');
                                      }}
                                    >
                                      Upload Lab Report
                                    </p>
                                    {message?.documentType?.some(
                                      (item) =>
                                        item?.type === 'lab-report' &&
                                        item?.isDocumentRequired
                                    ) ? (
                                      <p className="italic text-accent2-shades4 text-body-s text-right my-1">
                                        *Mandatory
                                      </p>
                                    ) : null}
                                  </>
                                ) : (
                                  ''
                                )}

                                {message?.showUserRemark && (
                                  <>
                                    {!showRemarkInput ? (
                                      <>
                                        <p
                                          className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                          onClick={() => {
                                            setShowRemarkInput(
                                              !showRemarkInput
                                            );
                                          }}
                                        >
                                          Remarks
                                        </p>
                                        {message?.documentType.length === 0 ||
                                        message?.documentType.filter(
                                          (item) => item?.isDocumentRequired
                                        )?.length === 0 ? (
                                          <p className="italic text-accent2-shades4 text-body-s text-right my-1">
                                            *Mandatory
                                          </p>
                                        ) : null}
                                      </>
                                    ) : (
                                      <div>
                                        <p className="txt-dgrey-600-12 mt-20 mb-5 flex items-center justify-between">
                                          <span>Remarks</span>
                                          {message?.documentType.length === 0 ||
                                          message?.documentType.filter(
                                            (item) => item?.isDocumentRequired
                                          )?.length === 0 ? (
                                            <span className="italic text-accent2-shades4 text-body-s text-right my-1">
                                              *Mandatory
                                            </span>
                                          ) : null}
                                        </p>{' '}
                                        <TextArea
                                          type="text"
                                          onChange={(e) =>
                                            setRemark(e.target.value)
                                          }
                                        />
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            ) : null}

                            {handleSubmit(message?.documentType)}
                            <p className="text-body-s text-secondary-shades6 mt-10px">
                              Last data to upload document is
                              <span className="font-semibold ml-4px">
                                {message?.documentsUploadAt}
                              </span>
                            </p>
                          </StatusContainer2>
                          {/* <div>{ele.activeDate}</div> */}
                        </div>
                      ) : null}

                      {message.isUser &&
                      message.actionTaken &&
                      message.userRemark ? (
                        <Message isUser={message.isUser}>
                          <span className="text-body-s font-semibold text-black">
                            Remarks:{' '}
                          </span>
                          <span className="text-black">
                            {message.userRemark}
                          </span>
                        </Message>
                      ) : null}
                    </MessageContainer>
                    <p
                      className={`text-sub ${
                        message.isUser
                          ? 'text-right mr-2 pr-1'
                          : 'text-left ml-2 pl-1'
                      } text-body-s`}
                    >
                      {message?.createdAt?.split(',')[0]}
                    </p>
                    {isViewerOpen && (
                      <ImageViewer
                        src={message?.documentImage}
                        currentIndex={currentImage}
                        onClose={closeImageViewer}
                        disableScroll={false}
                        backgroundStyle={{
                          backgroundColor: 'rgba(0,0,0,0.7)',
                          position: 'absolute',
                        }}
                        closeOnClickOutside={true}
                      />
                    )}
                  </>
                ))}
              </div>
            ))}
        </BodyContainer>
        <AttachmentInput
          type="file"
          id="photoAttachment"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={onImageDataReceive}
        />
        <AttachmentInput
          type="file"
          id="fileAttachment"
          accept=".pdf"
          style={{ display: 'none' }}
          onChange={onPDFDataReceive}
        />
        <AttachmentInput
          type="file"
          id="fileAttachment"
          accept=".pdf"
          style={{ display: 'none' }}
          onChange={onPDFDataReceive}
        />
        {showModal && (
          <UploadModal
            hideModal={() => hideModal()}
            handleAttachment={handleAttachment}
          />
        )}
        {showMessageModal ? (
          <MessageModal
            header={modalHeader}
            message={modalMessage}
            hideModal={() => hideModal()}
          />
        ) : (
          ''
        )}
      </OuterContainer>
    </FadeInTransition>
  );
};

export default QueryHistory;
